(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cp-local-amount"] && !Shopify.designMode) return;
  try {
    class LocalAmount extends HTMLElement {
    connectedCallback() {
      const eur = Number(this.dataset.eur || 0);
      if (!eur) return;

      const currency = (window.Shopify && window.Shopify.currency) || {};
      const code = currency.active || 'EUR';
      if (code === 'EUR') return;

      const rate = Number(currency.rate);
      if (!rate || !Number.isFinite(rate)) return;

      const amount = Math.ceil((eur * rate) / 10) * 10;
      const locale = document.documentElement.lang || 'fr';

      try {
        this.textContent = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: code,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(amount);
      } catch (error) {
        // Devise inconnue d'Intl : on conserve le fallback serveur en euros.
      }
    }
  }

  if (!customElements.get('local-amount')) {
    customElements.define('local-amount', LocalAmount);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-delivery-promise"] && !Shopify.designMode) return;
  try {
    class DeliveryPromise extends HTMLElement {
    connectedCallback() {
      this.render();
      // Recalcule le créneau au passage de 14 h, de minuit ou du week-end.
      this.timer = window.setInterval(() => this.tick(), 1000);

      // Masquer la promesse quand la variante sélectionnée est en rupture
      // (Horizon met à jour les buy-buttons en place, pas de re-render serveur).
      this.section = this.closest('.shopify-section');
      this.onVariantUpdate = (event) => {
        const resource = event && event.detail ? event.detail.resource : null;
        const html = event && event.detail && event.detail.data ? event.detail.data.html : null;
        const nextPromise = html ? html.querySelector('delivery-promise.pdp-delivery') : null;
        if (nextPromise) {
          this.dataset.preorder = nextPromise.dataset.preorder || 'false';
          this.dataset.preorderShippingDate = nextPromise.dataset.preorderShippingDate || '';
          this.dataset.preorderWithDate = nextPromise.dataset.preorderWithDate || '';
          this.dataset.preorderWithoutDate = nextPromise.dataset.preorderWithoutDate || '';
        }
        this.hidden = !resource || resource.available === false;
        if (!this.hidden) this.render();
      };
      if (this.section) {
        this.section.addEventListener('variant:update', this.onVariantUpdate);
      }
    }

    disconnectedCallback() {
      if (this.timer) window.clearInterval(this.timer);
      if (this.section && this.onVariantUpdate) {
        this.section.removeEventListener('variant:update', this.onVariantUpdate);
      }
    }

    get intlLocale() {
      return this.dataset.intlLocale || document.documentElement.lang || 'fr-FR';
    }

    get cutoffTimeZone() {
      return this.dataset.cutoffTimezone || 'Europe/Paris';
    }

    // Composantes calendaires d'un instant dans un fuseau donné.
    zonedParts(date, timeZone) {
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      });
      const parts = {};
      for (const part of formatter.formatToParts(date)) {
        if (part.type !== 'literal') parts[part.type] = Number(part.value);
      }
      // Certains moteurs rendent minuit comme "24" en hour12:false.
      if (parts.hour === 24) parts.hour = 0;
      return parts;
    }

    // Instant absolu correspondant à une date/heure civile dans un fuseau.
    // Deux passes pour rester juste autour des changements d'heure.
    zonedTimestamp(parts, timeZone) {
      const target = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, 0, 0);
      let timestamp = target;
      for (let pass = 0; pass < 2; pass += 1) {
        const seen = this.zonedParts(new Date(timestamp), timeZone);
        const seenUtc = Date.UTC(seen.year, seen.month - 1, seen.day, seen.hour, seen.minute, seen.second);
        timestamp += target - seenUtc;
      }
      return timestamp;
    }

    config(now = new Date()) {
      const cutoffHour = Number(this.dataset.cutoffHour || 14);
      const minDays = Number(this.dataset.minDays || 1);
      const maxDays = Number(this.dataset.maxDays || 2);

      // L'atelier vit à l'heure de Paris : le créneau se décide sur le
      // calendrier parisien, quel que soit le fuseau de la cliente.
      const paris = this.zonedParts(now, this.cutoffTimeZone);
      const parisToday = new Date(paris.year, paris.month - 1, paris.day);

      // Expédition uniquement les jours ouvrés : après l'heure limite ou le
      // week-end, le colis part le jour ouvré suivant.
      const shipsToday = this.isBusinessDay(parisToday) && paris.hour < cutoffHour;
      const shipDate = shipsToday ? parisToday : this.nextBusinessDay(parisToday);
      const dispatchDeadline = new Date(
        this.zonedTimestamp(
          {
            year: shipDate.getFullYear(),
            month: shipDate.getMonth() + 1,
            day: shipDate.getDate(),
            hour: cutoffHour,
          },
          this.cutoffTimeZone
        )
      );

      return {
        now,
        parisDayKey: `${paris.year}-${paris.month}-${paris.day}`,
        shipsToday,
        shipDate,
        dispatchDeadline,
        deliveryStart: this.addBusinessDays(shipDate, minDays),
        deliveryEnd: this.addBusinessDays(shipDate, maxDays),
      };
    }

    render() {
      const c = this.config();
      this.shipsToday = c.shipsToday;
      this.dayKey = c.parisDayKey;

      const isPreorder = this.dataset.preorder === 'true';
      const preorderDelivery = this.querySelector('[data-preorder-delivery]');
      if (preorderDelivery) preorderDelivery.hidden = !isPreorder;
      for (const element of this.querySelectorAll('[data-standard-delivery]')) {
        element.hidden = isPreorder;
      }

      if (isPreorder) {
        this.renderPreorder();
        return;
      }

      // Frise de suivi.
      this.setText('[data-step-order]', this.formatShortDate(c.now));
      this.setText('[data-step-ship]', this.formatShortDate(c.shipDate));
      this.setText('[data-step-delivery]', `${this.formatShortDate(c.deliveryStart)} - ${this.formatDay(c.deliveryEnd)}`);

      this.renderDispatch(c);
    }

    tick() {
      const c = this.config();
      // Changement de créneau (passage de 14 h à Paris ou de jour) : on
      // reconstruit la frise, la fenêtre et le libellé d'expédition.
      if (c.shipsToday !== this.shipsToday || c.parisDayKey !== this.dayKey) {
        this.render();
        return;
      }

      if (this.dataset.preorder !== 'true') {
        this.renderDispatch(c);
      }
    }

    // Un seul énoncé, toujours le même : le jour d'expédition promis, et le
    // temps qu'il reste pour l'obtenir. Aucune heure limite affichée, qui
    // laisserait croire qu'on ne prend plus les commandes passé 14 h.
    renderDispatch(config) {
      const label = this.formatDispatchLabel(config);
      const remaining = config.dispatchDeadline.getTime() - config.now.getTime();
      const value = this.formatDuration(remaining);

      const segments = (this.dataset.countdownShort || '').replace('{LABEL}', label).split('{TIME}');
      this.setText('[data-dispatch-prefix]', segments[0] || '');
      this.setText('[data-dispatch-value]', value);
      this.setText('[data-dispatch-suffix]', segments[1] || '');
    }

    renderPreorder() {
      const date = this.parseIsoDate(this.dataset.preorderShippingDate);
      const template = date ? this.dataset.preorderWithDate : this.dataset.preorderWithoutDate;
      const copy = date ? (template || '').replace('{DATE}', this.formatFullDate(date)) : template || '';
      this.setText('[data-preorder-copy]', copy);
    }

    // Écart en jours entre une date et le jour courant de la cliente : le
    // « demain » affiché est toujours celui de son calendrier à elle.
    daysFromToday(date, now) {
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const target = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      return Math.round((target - today) / 86400000);
    }

    formatDispatchLabel(config) {
      // Comparé au calendrier de la cliente : un jour d'expédition parisien
      // peut être « demain » pour elle si elle consulte depuis Montréal le soir.
      const daysUntilShipping = this.daysFromToday(config.shipDate, config.now);
      if (daysUntilShipping <= 0) return this.dataset.dispatchToday || '';
      if (daysUntilShipping === 1) return this.dataset.dispatchTomorrow || '';

      // Dans la semaine on nomme le jour (« Expédition lundi »), en accord avec
      // l'heure limite annoncée juste après (« avant lundi 14 h »).
      if (daysUntilShipping <= 6) {
        const weekday = new Intl.DateTimeFormat(this.intlLocale, { weekday: 'long' }).format(config.shipDate);
        return (this.dataset.dispatchWeekday || '').replace('{DAY}', weekday);
      }

      return (this.dataset.dispatchNext || '').replace('{DATE}', this.formatFullDate(config.shipDate));
    }

    formatDuration(milliseconds) {
      const totalSeconds = Math.max(0, Math.ceil(milliseconds / 1000));
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      // Les unités de rang inférieur passent sur deux chiffres pour que le
      // compteur ne « saute » pas de largeur à chaque seconde.
      const pad = (value) => String(value).padStart(2, '0');
      const chunks = [];
      if (days > 0) chunks.push(`${days} ${this.dataset.unitDay || 'j'}`);
      if (days > 0 || hours > 0) chunks.push(`${chunks.length ? pad(hours) : hours} ${this.dataset.unitHour || 'h'}`);
      if (chunks.length || minutes > 0) {
        chunks.push(`${chunks.length ? pad(minutes) : minutes} ${this.dataset.unitMinute || 'min'}`);
      }
      // Au-delà d'une journée, la seconde qui défile n'apporte rien et rend la
      // ligne interminable : on s'arrête aux minutes.
      if (days === 0) chunks.push(`${chunks.length ? pad(seconds) : seconds} ${this.dataset.unitSecond || 's'}`);

      return chunks.join(' ');
    }

    parseIsoDate(value) {
      if (!value) return null;
      const [year, month, day] = value.split('-').map(Number);
      const date = new Date(year, month - 1, day);
      return Number.isNaN(date.getTime()) ? null : date;
    }

    isBusinessDay(date) {
      const day = date.getDay();
      return day !== 0 && day !== 6;
    }

    nextBusinessDay(date) {
      const nextDate = new Date(date);
      do {
        nextDate.setDate(nextDate.getDate() + 1);
      } while (!this.isBusinessDay(nextDate));
      return nextDate;
    }

    addBusinessDays(date, days) {
      let nextDate = new Date(date);
      for (let i = 0; i < days; i += 1) {
        nextDate = this.nextBusinessDay(nextDate);
      }
      return nextDate;
    }

    formatFullDate(date) {
      return new Intl.DateTimeFormat(this.intlLocale, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }).format(date);
    }

    formatShortDate(date) {
      return new Intl.DateTimeFormat(this.intlLocale, {
        day: 'numeric',
        month: 'short',
      }).format(date);
    }

    formatDay(date) {
      return new Intl.DateTimeFormat(this.intlLocale, {
        day: 'numeric',
      }).format(date);
    }

    setText(selector, value) {
      const node = this.querySelector(selector);
      if (node && node.textContent !== value) node.textContent = value;
    }
  }

  if (!customElements.get('delivery-promise')) {
    customElements.define('delivery-promise', DeliveryPromise);
  }
  } catch(e) { console.error(e); }
})();

})();
